import React, { useEffect } from "react";
import Extract from "./FormStepModules/Extract";
import FormEnd from "./FormStepModules/FormEnd";
import InvalidData from "./FormStepModules/InvalidData";
import NonPartnerShareDetails from "./FormStepModules/NonPartnerShareDetails";
import PartnerShareDetails from "./FormStepModules/PartnerShareDetails";
import PartnerUseExternalAPI from "./FormStepModules/PartnerUseExternalAPI";
import PersonalDetails from "./FormStepModules/PersonalDetails";
import ProposalFound from "./FormStepModules/ProposalFound";
import ProposalRefused from "./FormStepModules/ProposalRefused";
import FormStepper, { IFormStep } from "./FormStepper";

import { Paragraph, Title, WebFormContainer } from "./styles";
import { IAdm, useDataFormContext } from "@/context/FormDataContext";
import { listAdms } from "@/services/adm";

/**
 * @returns the webform component
 */
export default function WebForm(): React.JSX.Element {
  const formSteps: Array<IFormStep> = [
    {
      // Step 0
      all: <PersonalDetails />,
    },
    {
      // Step 1
      partner: <PartnerShareDetails />,
      partnerWithStatement: <PartnerShareDetails />,
      workable: <NonPartnerShareDetails />,
      nonworkable: <NonPartnerShareDetails />,
    },
    {
      // Step 2
      partner: <FormEnd />,
      partnerWithStatement: <Extract />,
      workable: <Extract />,
      nonworkable: <Extract />,
    },
    {
      // Step 3
      partnerWithStatement: <FormEnd />,
      workable: <FormEnd />,
      nonworkable: <FormEnd />,
    },
    {
      // Step 4 - Proposal found
      partner: <ProposalFound />,
      partnerWithStatement: <ProposalFound />,
    },
    {
      // Step 5 - Partner use external API
      partner: <PartnerUseExternalAPI />,
      partnerWithStatement: <PartnerUseExternalAPI />,
    },
    {
      // Step 6 - Invalid data
      partner: <InvalidData />,
      partnerWithStatement: <InvalidData />,
    },
    {
      // Step 7 - Proposal refused
      partner: <ProposalRefused />,
      partnerWithStatement: <ProposalRefused />,
    },
  ];
  const { currentFormStep, currentFormVariation, setAdmsList } =
    useDataFormContext();

  /**
   * Fetch adms list
   */
  async function getAdmList(): Promise<void> {
    const urlParams = new URLSearchParams(window.location.search);
    const adm = urlParams.get("YWRt") ?? "";
    try {
      const admList = await listAdms(adm);
      if (admList?.data) {
        setAdmsList(admList.data as unknown as Array<IAdm>);
      }
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    getAdmList();
  }, []);

  return (
    <WebFormContainer>
      <Title>
        E aí, <strong>quer uma proposta?</strong>
      </Title>
      <Paragraph>Preencha o formulário para receber uma proposta.</Paragraph>
      <FormStepper
        currentStep={currentFormStep}
        variation={currentFormVariation}
        stepList={formSteps}
      />
    </WebFormContainer>
  );
}
